import useSubscription from 'hooks/use-subscription';

const useForceReloadSubscriber = () => {
  useSubscription({
    stream: 'frontend-reload',
    key: 'global',
    onEvent: async () => {
      console.log('🔄 Refreshing page...');
      window.location.reload();
    },
    skipInitEvent: true
  });
};

export default useForceReloadSubscriber;
